/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_PositionInputs */



/**
* | output |
* | --- |
* | "Position" |
*
* @param {Event_Group_Sync_Property_PositionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_position = /** @type {((inputs?: Event_Group_Sync_Property_PositionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_PositionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position")
	if (locale === "it") return /** @type {LocalizedString} */ ("Position")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Position")
	if (locale === "es") return /** @type {LocalizedString} */ ("Position")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Position")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Position")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Position")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Position")
	return /** @type {LocalizedString} */ ("Position")
});